
import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import usePermission from "../../../config/permissions";
import { BASE_URL, IMAGE_URL } from "./../../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { Office, SearchSmall, AddwithWhiteCircle, DownloadIcon } from "../../AllSvg";
import { AddSlipBuilderCategory, DeleteSlipBuilderCategory, UpdateSlipBuilderCategory, ViewSlipBuilder } from "./SlipBuilderComponents";
// import { handleErrorToast } from "../../CustomFunctions";
// import { formatDate } from "../../Date";
// import { customSortByKey, DownloadBulkDocumentsAsZip, ViewFile, CustomTooltip } from "../../CustomFunctions";
import { AddSlipBuildDetails, DeleteSlipBuildDetails, UpdateSlipBuildDetails } from "./SlipBuilderComponents";
import { CustomImageModal, CustomTooltip, handleErrorToast } from "../../CustomFunctions";
import { formatDate, formatDateTime } from "../../Date";
import UserDefaultLogo from "../../UserDetails/UserDefaultLogo";
import { customSortByKey } from "../../CustomFunctions";
import { ViewLetterBuilder } from "../LetterBuilderManagement/LetterTemplateComponents";

const SlipBuilderCategories = () => {

    const [buffer, setBuffering] = useState(false);
    const [slipBuilderCategories, setSlipBuilderCategories] = useState([]);
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getSlipBuilderCategories = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(`${BASE_URL}/wfm/slip-category-data-by-subcompany/${toggleCompany}/`);
            setSlipBuilderCategories(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getSlipBuilderCategories();
    }, [toggleCompany]);

    return (
        <div>
            <div className="table-css-white-background">
                <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
                    <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
                        <div className="repo-heading font-weight500 font-size-heading">
                            Categories for Slip Builder
                        </div>
                        <div className="field-cont">
                            {SUPER_ADMIN && <div title="Select SubCompany" className="table-searchh dropdown-container field-cont-div">
                                <Office />
                                <select
                                    value={toggleCompany}
                                    onChange={(e) => setToggleCompany(e.target.value)}
                                    className="dropdown font-size-subheading  "
                                    style={{ cursor: "pointer" }}
                                >
                                    <option value="null">Select SubCompany</option>
                                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                </select>
                            </div>}
                            <div title='Search' className="table-searchh">
                                <div>
                                    <SearchSmall />
                                    <input
                                        placeholder="Search"
                                        className="navbar-inputt font-weight400  font-size-text"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                            </div>
                            <AddSlipBuilderCategory getSlipBuilderCategories={getSlipBuilderCategories} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
                        </div>
                    </div>
                    <div className='table-box  scroll-container-table' style={{ width: "100%" }}>
                        <table className="table-css" >
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S. No.</th>
                                    <th className="table-heading-text text-center">Code</th>
                                    <th className="table-heading-text text-center">Name</th>
                                    <th className="table-heading-text text-center">Description</th>
                                    {toggleCompany === 'null' && <th className="table-heading-text text-center">Sub Company</th>}
                                    <th className="table-heading-text text-center">Created At</th>
                                    <th className="table-heading-text text-center">Last Update</th>
                                    <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>//buffering logic
                            ) : (
                                <tbody>
                                    {slipBuilderCategories
                                        ?.filter((e) =>
                                            (e.other_name || "").toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .sort((a, b) =>
                                            a.other_name?.localeCompare(b.other_name, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .sort((a, b) =>
                                            a.sub_company_title?.localeCompare(b.sub_company_title, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="custom-table-head-td ">
                                                    <td className="table-body">{index + 1}</td>
                                                    <td className="table-body text-center ">{i.code}</td>
                                                    <td className="table-body text-center ">{i.name}</td>
                                                    <td className="table-body text-center ">{i.description}</td>
                                                    {toggleCompany === 'null' && <td className="table-body text-center">{i.sub_company_title}</td>}
                                                    <td className="table-body align-center">
                                                        {formatDateTime(i?.created_at).longdate}
                                                        <br />
                                                        <small>{formatDateTime(i?.created_at).time}</small>
                                                    </td>


                                                    <td className="table-body align-center">
                                                        <>
                                                            {i.updated_by &&
                                                                <>
                                                                    <CustomImageModal customStyle>
                                                                        {i.updated_by_profilepic ? (
                                                                            <img
                                                                                src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                                                                alt="profile" className="profile-img"
                                                                            />
                                                                        ) : (
                                                                            <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                        )}
                                                                    </CustomImageModal>
                                                                    <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                                                                    {/* At- */}
                                                                </>
                                                            }
                                                            {i.updated_by ?
                                                                <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                                                                :
                                                                <>
                                                                    {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                                                                    <br />
                                                                    <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                                                                </>}
                                                        </>
                                                    </td>
                                                    <td className="table-body text-right" style={{ justifyContent: 'right' }}>

                                                        <div className='flex-row justify-end'>
                                                            <UpdateSlipBuilderCategory
                                                                i={i}
                                                                getSlipBuilderCategories={getSlipBuilderCategories}
                                                                SUB_COMPANIES={SUB_COMPANIES}
                                                                SUPER_ADMIN={SUPER_ADMIN}
                                                            />
                                                            <DeleteSlipBuilderCategory
                                                                i={i}
                                                                getSlipBuilderCategories={getSlipBuilderCategories} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}


const SlipBuilderTemplates = () => {
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [buffer, setBuffering] = useState(true); //buffering logic
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [slipTemplate, setSlipTemplatesData] = useState([]);
    const [slipBuilderCategories, setSlipBuilderCategories] = useState([]);
    const [empList, setEmpList] = useState([]);
    const getSlipBuilderTemplate = async () => {
        setBuffering(true); // Start Buffering
        try {
            const template = await axios.get(`${BASE_URL}/wfm/slip-builder-data-by-subcompany/${toggleCompany}/`);
            setSlipTemplatesData(template.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);
        }
    };

    const [lettersTemplate, setLettersTemplateData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getSlipBuilderCategories = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(`${BASE_URL}/wfm/slip-category-data-by-subcompany/${toggleCompany}/`);
            setSlipBuilderCategories(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering(false);
        }
    }

    const getLetterTemplatesList = async () => {

        try {
            const template = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${toggleCompany}/`
            );
            setLettersTemplateData(template.data);
        } catch (err) {
            handleErrorToast(err);
        }
    };

    const getAllEmp_code = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            const sortedList = customSortByKey(res.data, "emp_code");

            setEmpList(sortedList);
        } catch (err) {
        }
    };

    useEffect(() => {
        if (toggleCompany && toggleCompany != "null")
            getAllEmp_code(toggleCompany);
    }, [toggleCompany])

    useEffect(() => {
        getLetterTemplatesList()
    }, [])

    useEffect(() => {
        getSlipBuilderTemplate();
        getSlipBuilderCategories();
    }, [toggleCompany])

    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Slip Templates</div>
                <div className="field-cont">
                    {SUPER_ADMIN ?
                        <div className="table-searchh dropdown-container field-cont-div">
                            <Office />
                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                    }
                    <div className="table-searchh field-cont-div">
                        <div>
                            <SearchSmall />
                        </div>
                        <div>
                            <input
                                placeholder="Search"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                    <AddSlipBuildDetails SUPER_ADMIN={SUPER_ADMIN} SUB_COMPANIES={SUB_COMPANIES} getSlipBuilderData={getSlipBuilderTemplate} SLIP_CATEGORIES={slipBuilderCategories} LETTER_TEMPLATES={lettersTemplate} empList={empList} />

                </div>
            </div>
            {/* <SectorsDetailForm /> */}
            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">S.No</th>
                        <th className="align-center">Slip Template Name</th>
                        <th className="align-center">Company</th>
                        <th className="align-center">Preview Template</th>
                        <th className="align-center">Description </th>
                        <th className="align-center">Category</th>
                        <th className="align-center">Letter Template Name</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-center">Action</th>
                    </tr>
                </thead>
                {buffer ? <div className="spinner"></div> :
                    <tbody>
                        {slipTemplate
                            ?.sort((a, b) => a.template_name - b.template_name)
                            ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>

                                        <td className="align-center">{i?.name}</td>
                                        <td className="align-center">
                                            {i?.sub_company_title}
                                        </td>

                                        <td key={i.id} className="align-center">
                                            <ViewSlipBuilder
                                                buttonDisplay={'Eye-Name'}
                                                i={i}
                                            />
                                        </td>

                                        <td className="align-center">
                                            {i?.description}
                                        </td>
                                        <td className="align-center">
                                            {i?.category?.name}
                                        </td>
                                        <td className="align-center">
                                            {i?.letter_template_name}
                                        </td>

                                        {/* <td className="align-center">{formatDate(i?.created_at)}</td> */}
                                        <td className="align-center">
                                            {formatDateTime(i?.created_at).longdate}
                                            <br />
                                            <small>{formatDateTime(i?.created_at).time}</small>
                                        </td>
                                        <td className="align-center">
                                            <>
                                                {i.updated_by &&
                                                    <>
                                                        <CustomImageModal customStyle>
                                                            {i.updated_by_profilepic ? (
                                                                <img
                                                                    src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                                                    alt="profile" className="profile-img"
                                                                />
                                                            ) : (
                                                                <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                            )}
                                                        </CustomImageModal>
                                                        <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                                                        {/* At- */}
                                                    </>
                                                }
                                                {i.updated_by ?
                                                    <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                                                    :
                                                    <>
                                                        {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                                                        <br />
                                                        <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                                                    </>}
                                            </>
                                        </td>
                                        <td className="align-center" >
                                            <div className="flex-row ">
                                                <UpdateSlipBuildDetails
                                                    i={i}
                                                    SUPER_ADMIN={SUPER_ADMIN}
                                                    SUB_COMPANIES={SUB_COMPANIES}
                                                    getSlipBuilderData={getSlipBuilderTemplate}
                                                    SLIP_CATEGORIES={slipBuilderCategories}
                                                    LETTER_TEMPLATES={lettersTemplate}
                                                    empList={empList}
                                                />

                                                <DeleteSlipBuildDetails
                                                    i={i}
                                                    getSlipBuilderData={getSlipBuilderTemplate}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                    </tbody>
                }
            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};




export {
    SlipBuilderCategories,
    SlipBuilderTemplates,
};




















